import {Action, ActionReducer, createReducer} from '@ngrx/store';
import {PeriodsState} from './periods';

const _reducer: ActionReducer<PeriodsState> = createReducer(
  {
    periods: [
      { type: 'today', name: 'periods.today' },
      { type: 'yesterday', name: 'periods.yesterday' },
      { type: 'this_week', name: 'periods.this_week' },
      { type: 'last_7_days', name: 'periods.last_7_days' },
      { type: 'last_week', name: 'periods.last_week' },
      { type: 'last_14_days', name: 'periods.last_14_days' },
      { type: 'this_month', name: 'periods.this_month' },
      { type: 'last_30_days', name: 'periods.last_30_days' },
      { type: 'last_month', name: 'periods.last_month' },
      { type: 'this_year', name: 'periods.this_year' },
      { type: 'custom', name: 'periods.custom' }
    ]
  } as PeriodsState
);

export const periodsReducer: ActionReducer<any> = (state: PeriodsState, action: Action) => {
  return _reducer(state, action);
};
